import React, { useEffect } from "react";
// import ActivityRenderer from "./ActivityRenderer/ActivityRenderer";
import { useNavigate, useParams } from "react-router-dom";
import { useStatemachineContext } from "../../context/StatemachineContext";
import { useTreeContext } from "../../context/TreeDataContext";
import StateBlueprintRenderer from "./StateBlueprint/StateBlueprintRenderer";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";

const StateMachineRenderer = () => {
  const { stateMachineExplorerData } = useTreeContext();
  const { setSelectedStateMachine } = useStatemachineContext();
  const { smId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (!stateMachineExplorerData) return;
    const file = getFolderFileById(stateMachineExplorerData, smId);

    if (file) {
      const [stateId, type] = file.parentData.split("/");
      const obj = {
        id: file.id,
        name: file.name,
        stateid: stateId,
        statename: type
      };
      setSelectedStateMachine(obj);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smId]);

  return (
    <div className="sm_outer_container content_main_section">
      <StateBlueprintRenderer />;
    </div>
  );
};

export default StateMachineRenderer;
